"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCapability = void 0;
var UserCapability;
(function (UserCapability) {
    UserCapability["LOGIN_INFO_UPDATE"] = "login_info:update";
    UserCapability["NAVIGATION_GO_TO_TS1"] = "navigation:go_to_ts1";
})(UserCapability || (exports.UserCapability = UserCapability = {}));
